import BaseChannelSerializer from '@square/dashboard-data/serializers/channels/base-channel-serializer';
import { ResolutionSource } from '@square/dashboard-data/models/channels/account-issue';
export const SQUARE_ONLINE_RESOLVABLE_CODES = new Set(['misrepresentation_of_self_or_products_missing_refund_policy_policy']);
export default BaseChannelSerializer.extend({
  normalize(typeClass, hash) {
    const isResolvableInSquareOnline = SQUARE_ONLINE_RESOLVABLE_CODES.has(hash.code);
    if (isResolvableInSquareOnline) {
      // eslint-disable-next-line no-param-reassign
      hash.resolution_source = ResolutionSource.SquareOnline;
    } else {
      // eslint-disable-next-line no-param-reassign
      hash.resolution_source = ResolutionSource.GoogleMerchantCenter;
    }
    return this._super(typeClass, hash);
  }
});